import { UiService } from './../../shared/services/ui/ui.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  resetForm: UntypedFormGroup;
  isLoading: boolean;
  resetPasswordSent: boolean;

  constructor(
    private authSrv: AuthService,
    private uiSrv: UiService,
    private router: Router
  ) { }

  ngOnInit() {
    this.initForm();
  }

  onSubmit() {
    this.isLoading = true;

    this.authSrv.requestPasswordReset(this.resetForm.value.email.toLowerCase())
      .subscribe({
        next: (value) => {
          this.isLoading = false;
          this.resetPasswordSent = true;
          this.uiSrv.showSnackbar("Demande de réinitialisation de mot de passe effectuée. Veuillez vérifier vos mails indésirables.", false, 6000)
          this.router.navigate(['/home']);
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  private initForm() {
    this.resetForm = new UntypedFormGroup({
      email: new UntypedFormControl('', {
        validators: [Validators.required, Validators.email]
      })
    });
  }
}
